module.exports = __webpack_public_path__ + "img/member-mobile.cbf20a38.webp";